// Copyright (C) 2015 Minted Inc.
// All Rights Reserved

/**
 * Main js controller for challenge hub page
 * - Displays different panels based on challenge state
 *
 * Renders panels that are challenge related and that do not depend
 * on external data
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function (M, _, $, Backbone) {
  'use strict';

  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Challenge = M.Community.View.Challenge || {};

  M.Community.View.Challenge.ChallengeHub = Backbone.View.extend({
    instrTarget: M.GA.TRACK_EVENT_CATEGORY.COMMUNITY_VOTING_GALLERY,

    // Query strings for filtering, sorting, paging
    submissionPageQueryStr: "submission_page",
    browseByQueryStr: "filter",
    sortByQueryStr: "sort",
    itemCountQueryStr: "count",

    // Parameter value for "view all pages"
    viewAllParamVal: "all",

    // default sort for designs in the submissions panel
    defaultSort: 'random',

    events : {
      'click #actionButton' : 'topBannerActionButton'
    },

    initialize: function() {
      M.required(this.model);

      // map page sections jQuery objects to variables
      this.$el = $(this.el);
      this.$bannerContainer = this.$el.find('#bannerContainer');
      this.$panelsContainer = this.$el.find('#panelsContainer');
      this.$activityFeedPanel = this.$el.find('.activityFeedPanel');
    },

    render: function() {
      var that = this;

      // render the banner
      this.$bannerContainer.html(this.getHtmlTopBanner());

      this.attachActivityFeedHtml();

      // list of navigation links to pass to nav bar builder
      var navigationSections = [];

      var expectedPanelsForState =
        this.getExpectedPanelsForStateAndKillSwitch(this.options);

      // Loop over panel order; render the panels that are expected for
      // the current challenge state
      _.each(PANEL_FCN_ORDER, function(renderFnName) {
        if (_.contains(expectedPanelsForState, renderFnName)) {
          var renderFn = M.Community.View.Challenge.ChallengeHub[renderFnName];
          var panelElementId = '#' + PANEL_TO_ELEMENT_ID[renderFnName];

          if (typeof(renderFn) === 'function') {
            var panelElement = that.$el.find(panelElementId);
            renderFn(that, panelElement);

            if (_.contains(_.keys(PANEL_TO_NAV_LINK_STR_MAP), renderFnName)) {
              navigationSections.push({
                'sectionTitle': PANEL_TO_NAV_LINK_STR_MAP[renderFnName],
                'sectionId': panelElementId
              });
            }
          } else {
            _serverLogger.error(
              'Challenge hub - calling nonexistent render function: ' +
              renderFnName);
          }
        }
      });
      this.appendNavBar(navigationSections);

      if (window.location.hash.length !== 0) {
        this.offsetAnchor(window.location.hash.substring(1));
      }

      return this;
    },

    getExpectedPanelsForStateAndKillSwitch: function(viewOptions) {
      var expectedPanelsForStateAndKillswitch =
        _.clone(CHALLENGE_STAGE_PANELS_MAP[this.model.get('state')]);

      if (viewOptions.isChallengeHubPartiallyDisabled ||
          viewOptions.isFeedbackPollsDisabled) {
        // If killswitch is on, then don't render the feedback and polls
        // widget.
        var feedbackPollsIndex = expectedPanelsForStateAndKillswitch.indexOf(
          'renderFeedbackAndPolls');
        expectedPanelsForStateAndKillswitch.splice(feedbackPollsIndex, 1);
      }
      return expectedPanelsForStateAndKillswitch;
    },

    /**
     * Renders top challenge banner - this section is always loaded
     */
    getHtmlTopBanner: function() {
      var templateHTML = M.Template.Community.Challenge.ChallengeHubTopBanner({
        challengeTitle: this.model.get('title'),
        challengeCategory: this.model.get('category'),
        challengeState: this.model.get('state'),
        challengeDateTitle: this.model.getDeadlineLabelText(),
        challengeDateStr: this.model.getBannerDateStr(),
        actionButtonDisabled: M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[
          this.model.get('state')]['bannerActionButtonDisabled'],
        actionButtonUrl: this.model.getActionButtonUrl()
      });
      return templateHTML;
    },

    appendNavBar: function(navigationSections) {
      var navigationBar = new M.Community.View.Util.InPageNavigationBar ({
        inPageSections: navigationSections,
        $containerEl: this.$el.find('.inPageNavigation'),
        shouldCreateStickyHeader: true
      });
    },

    offsetAnchor: function(targetFragment) {
      var that = this;
      window.setTimeout(function() {
        if (targetFragment == M.Config.ChallengeConfig.url_fragments.winners)
        {
          that.scrollToSection(M.COMMUNITY.CHALLENGE.PANEL_ID['winners_panel']);
        }
        else if (targetFragment == M.Config.ChallengeConfig.url_fragments.submissions)
        {
          that.scrollToSection(M.COMMUNITY.CHALLENGE.PANEL_ID['submissions_panel']);
        }
      }, 750);
    },

    attachActivityFeedHtml: function() {
      if (this.model.get('state') ===
            M.Config['ChallengeConfig'].state.setup.id ||
          this.model.get('state') ===
            M.Config['ChallengeConfig'].state.published.id) {
        // don't show activity feed in setup or published state
        return;
      }

      new M.Community.View.Util.ActivityFeedPanel({
        activityList: this.options.activityTileDicts,
        $parentContainerEl: this.$activityFeedPanel
      });
    },

    topBannerActionButton: function() {
      switch(this.model.get('state')) {
        case M.Config['ChallengeConfig'].state.nominate.id:
        case M.Config['ChallengeConfig'].state.restricted_vote.id:
        case M.Config['ChallengeConfig'].state.submission_closed.id:
          this.scrollToSection(M.COMMUNITY.CHALLENGE.PANEL_ID['submissions_panel']);
          break;
        case M.Config['ChallengeConfig'].state.published.id:
          this.scrollToSection(M.COMMUNITY.CHALLENGE.PANEL_ID['winners_panel']);
          break;
      }
    },

    scrollToSection: function(panel_id) {
      var actionButtonInnerHeight = this.$el.find('#actionButton').innerHeight();
      var winnersScrollTarget =
        $(panel_id).offset().top - actionButtonInnerHeight;
      M.Community.View.Util.Common.scrollToSection(winnersScrollTarget);
    },

  }, {

    RECENT_COMMENTS_LIMIT : 2,
    /***
     * Static render* functions here are static because they are looked
     * up by string name in the js namespace.
     ***/

    renderFeedbackAndPolls: function(challengeHubView, $parentPanelEl) {
      var feedbackPanelOptions = challengeHubView.options.feedbackPanelOptions;
      var $feedbackPanel = M.Community.View.Challenge.ChallengeHub.
        _getFeedbackView(feedbackPanelOptions);

      var pollingInfo = challengeHubView.options.pollingInfo;
      var $pollPanelEl = M.Community.View.Challenge.ChallengeHub.
        _getPollsHtml(pollingInfo);

      $parentPanelEl.find('#feedbackPanel').append($feedbackPanel);
      $parentPanelEl.find('#pollingPanel').append($pollPanelEl);
    },

    /**
     * Extra setup for the submissions section. The actual design elements
     * have already been created in mako code; create and attach social links
     * widgets.
     *
     * @param challengeHubView
     * @param $parentPanelEl - container element for this panel
     *
     * TODO: Refactor out some of this code / the private helper methods
     * to a common file if we ever need to render a list of designs elsewhere.
     */
    renderDesignSubmissions: function(challengeHubView, $parentPanelEl) {
      // Put the submissions panel in a show-hide panel
      var currQueryParams = M.Url.parseCurrentQuery();
      var showExpanded = false;
      if (currQueryParams[challengeHubView.submissionPageQueryStr]) {
        showExpanded = true;
      }
      var localStorageExpandKey = M.LOCAL_STORAGE_KEYS.COMMUNITY.
        CHALLENGE_HUB.SHOW_SUBMISSIONS_PANEL_EXPANDED;
      M.Community.View.Challenge.ChallengeHub._createShowHidePanel(
        $parentPanelEl, 1, 'designsRow', 'pagerControlsWrapper',
        showExpanded, localStorageExpandKey);

      // Create the dropdowns for browsing by and sorting by and item count
      var $browseByDropdownEl = $parentPanelEl.find('.browseByDropdown');
      var $sortedByDropdownEl = $parentPanelEl.find('.sortedByDropdown');
      var $itemCountDropdownEl = $parentPanelEl.find('.itemCountDropdown');

      M.Community.View.Challenge.ChallengeHub._createDropdown(
        $browseByDropdownEl, challengeHubView.options.browseByDropdownOptions,
        "BROWSE BY", challengeHubView.browseByQueryStr,
        challengeHubView.instrTarget,
        M.GA.TRACK_EVENT_ACTION.FILTER_SELECTED,
        $parentPanelEl.attr('id'),
        challengeHubView.submissionPageQueryStr,
        null);

      M.Community.View.Challenge.ChallengeHub._createDropdown(
        $sortedByDropdownEl, 
        challengeHubView.options.sortedByDropdownOptions,
        "SORT BY", 
        challengeHubView.sortByQueryStr,
        challengeHubView.instrTarget,
        M.GA.TRACK_EVENT_ACTION.SORT_DROPDOWN_CLICK,
        $parentPanelEl.attr('id'),
        challengeHubView.submissionPageQueryStr);

      M.Community.View.Challenge.ChallengeHub._createDropdown(
        $itemCountDropdownEl, 
        challengeHubView.options.itemCountDropdownOptions,
        "SHOW", 
        challengeHubView.itemCountQueryStr,
        challengeHubView.instrTarget,
        null,
        $parentPanelEl.attr('id'),
        challengeHubView.submissionPageQueryStr);

      // Attach various widgets on hover for each of the design items
      _.each($parentPanelEl.find('.item'), function(item) {
        var $designItem = $(item);
        var designId = $designItem.attr('design_id');
        var designRatingVal = parseInt($designItem.attr('design_rating'));

        // Create an overlay with facebook/pinterest pin buttons
        M.Community.View.Challenge.ChallengeHub.
          _constructAndAttachSocialWidgetsOverlay(challengeHubView,
            designId, $designItem);

        // Attach click handler for the "like" button
        M.Community.View.Challenge.ChallengeHub._attachLikeButtonHandlers(
          $designItem.find('.fullLikeButton'), designId);

      });
    },

    /*
     * Start of helper methods to render the submissions panel
     */
    _createShowHidePanel: function($parentPanelEl, numObjects, classToFilter,
      pageClass, showExpanded, localStorageExpandKey) {
      var $showHidePanel = new M.Community.View.Util.ShowHide({
        numObjectsToShow: numObjects,
        classToFilter: classToFilter,
        pageClass: pageClass,
        itemsParentPanelEl: $parentPanelEl,
        showExpanded: showExpanded,
        saveExpandSettingToLocalStorage: true,
        localStorageExpandKey: localStorageExpandKey
      });
      $showHidePanel.$el.insertAfter($parentPanelEl);
    },

    _createDropdown: function(
      $dropdownElement, 
      sortOptions, 
      pickerLabel,
      queryParamStr, 
      instrTarget, 
      instrAction, 
      anchorTagToLoad, 
      pageParamStr) {
      var currQueryParams = M.Url.parseCurrentQuery() || {},
        valueForQueryParam = currQueryParams[queryParamStr],
        selectedSortOption;

      if (valueForQueryParam) {
        selectedSortOption = valueForQueryParam;
      } else {
        // if there's no option selected, just choose the first option
        selectedSortOption = sortOptions[0]['option_val'];
      }

      var dropdownListModel = new M.Model.DropdownPicker({
        sortOptionsList: sortOptions,
        selectedSortOption: selectedSortOption
      });
      var dropdownPicker = new M.View.DropdownPicker({
        model: dropdownListModel,
        pickerLabel: pickerLabel
      });
      $dropdownElement.html(dropdownPicker.render().el);

      // Create a handler on selection of dropdown item
      var optionChangeHandler = function(dropdownListModel) {
        var selectedSortOption = dropdownListModel.getSelectedSortOption();

        var gaData = {}, trackData = {};
        gaData['target'] = trackData['feature'] = instrTarget;
        gaData['action'] = trackData['event'] = instrAction;
        gaData['label'] = trackData['label'] = selectedSortOption;
        // TODO: do we want to pass in a redirect url and allow a 200 ms
        // delay before redirecting? This would improve send rate of GA
        // events, but hurt latency.
        M.sendTrackAPIAndGAEvent(gaData, trackData);

        var params = M.Url.parseCurrentQuery();

        // Remove the query parameter for the page so we always go back to
        // the first page when a new dropdown item is selected
        if (pageParamStr && pageParamStr in params) {
          delete params[pageParamStr];
        }

        var additionalParams = {};
        additionalParams[queryParamStr] = selectedSortOption;
        _.extend(params, additionalParams);
        // Redirect the page with the new query params.
        // Also add on the anchor tag to jump back to this section
        var target = window.location.pathname + '?' + $.param(params) +
          '#' + anchorTagToLoad;
        M.Url.HandleRedirect(target);
      };

      dropdownListModel.bind("change:selectedSortOption", optionChangeHandler);
    },

    /*
     * Creates an overlay with pin to inspiration board, facebook, pinterest
     * buttons for a single design item.
     */
    _constructAndAttachSocialWidgetsOverlay: function(challengeHubView,
        designId, $designItem) {
      var designName = $designItem.attr('design_name');
      var designUsername = $designItem.attr('design_username');
      var designRatingUrl = M.BASE_URL + $designItem.find('.designImage').attr('href');
      var designImgUrl = $designItem.find('.designImageQL').attr('src');

      var shareLinksOptions = M.Community.View.Challenge.ChallengeHub.
        _composeShareLinksOptions(designId, designRatingUrl,
          designName, designUsername, designImgUrl);

      var favShareLinkWidget = new M.View.FavoriteAndShareLinks({
        shareLinksOptions: shareLinksOptions,
      });
      $designItem.find('.socialButtons').append(favShareLinkWidget.render().$el);

      // Add hover handlers for hiding/showing the overlay that contains the
      // social buttons
      var $overlay = $designItem.find('.designOverlayContainer');
      $designItem.find('.designImageBox').hover(
          function() { $overlay.show(); },
          function() { $overlay.hide(); }
      );
    },

    _composeShareLinksOptions: function(designId, designRatingUrl, designName,
        designUsername, imageUrl) {
      var storyJson = {
        url: designRatingUrl,
        title: designName,
        description: designName + ' by ' + designUsername + ' for Minted.',
        imageUrl: imageUrl
      };
      var shareLinksOptions = {
        trackingParams: true,
        medium: M.GA.SHARE_MEDIUM.DROPDOWN_VOTE,
        campaign: M.GA.SHARE_MEDIUM.CAMPAIGN_BOARDS,
        socialTrackingIdentifier: designId,
        socialTrackingPageType: M.GA.TRACK_SOCIAL_PAGE_TYPE.DESIGN_CHALLENGE,
        socialTrackingPrefix: M.GA.TRACK_SOCIAL_NETWORK_PREFIX.CHALLENGE,
        story: storyJson,
        useNewIcons: false
      };
      return shareLinksOptions;
    },

    _attachLikeButtonHandlers: function($likeButtonEl, designId) {
      var urlPaths = { designLikeUrlName: '/design-rating/' + designId }
      var isLiked = $likeButtonEl.data('is-liked');
      var likeModel = new M.Model.DesignLike({
        is_liked: isLiked,
        urlPaths: urlPaths
      });

      $likeButtonEl.click(function() {
        if (likeModel.get('is_liked') === true) {
          likeModel.set({'is_liked': false });
          $(this).find('.like').show();
          $(this).find('.unlike').hide();
        } else {
          likeModel.set({'is_liked': true });
          $(this).find('.like').hide();
          $(this).find('.unlike').show();
        }
        var isLikedStr = (likeModel.get('is_liked') ? "like" : "unlike");
        var data = {
          'action': 'design_like',
          'param': isLikedStr
        }
        // calling php because email logic is not present on python side
        // TODO - migrate design emails to Python and implement python
        // endpoint for this backbone sync call
        likeModel.save(data);
      });
    },

    /*
     * End helper methods to render the submissions panel
     */

    _getFeedbackView: function(panelOptions) {
      var TITLE = 'feedback';
      if(!panelOptions || (!panelOptions['designThumbnail'] && !panelOptions['feedbackRequestMsg'])) {
        var noFeedbackPanel = new M.Community.View.Challenge.SquarePanel({
          title: TITLE,
          emptyMsg: "You've answered all open feedback requests.",
          helpText: "Learn how to ask for feedback.",
          helpLink: "https://minteddesign.zendesk.com/hc/en-us/articles/115003614863-How-can-I-get-feedback-on-my-work-from-other-artists-"
        });
        return noFeedbackPanel.render().html();
      }

      var feedbackPanelOptions = {
        title: TITLE,
        actionButtonUrl: panelOptions['designRatingPageUrl'],
        actionButtonText: panelOptions['actionButtonText'],
        actionButtonInstrAction: "M.GA.TRACK_EVENT_ACTION.GIVE_FEEDBACK_CLICK",
        challengeName: panelOptions['challengeName'],
        challengeId: panelOptions['challengeId'],
        commentsUrlPath: panelOptions['commentsUrlPath'],
        designId: panelOptions['designId'],
        designName: panelOptions['title'],
        designerStatus: panelOptions['designerStatus'],
        designThumbnail: panelOptions['designThumbnail'],
        feedbackGalleryUrlPath : panelOptions['feedbackGalleryUrlPath'],
        feedbackRequestMsg: panelOptions['feedbackRequestMsg'],
        designerName: panelOptions['designerName'],
        designerLocation: panelOptions['designerLocation'],
        designerAvatarUrl: panelOptions['designerAvatarUrl'],
        designRatingPageUrl: panelOptions['designRatingPageUrl'],
        designerProfilePageUrl: panelOptions['designerProfilePageUrl'],
        recentCommentsLimit: M.Community.View.Challenge.ChallengeHub.RECENT_COMMENTS_LIMIT,
        truncateLength: '110'
      };

      var feedbackComponent = new M.Community.View.Challenge.FeedbackComponent(
        feedbackPanelOptions);
      return feedbackComponent.$containerEl;
    },

    _getPollsHtml: function(pollingInfo) {
      var headerText = 'polling now';
      // Empty state for panel
      if (!pollingInfo) {
        var noPollPanel = new M.Community.View.Challenge.SquarePanel({
          title: headerText,
          emptyMsg: "You've answered all polls.",
          helpText: "Learn how to start a poll.",
          helpLink: "https://minteddesign.zendesk.com/hc/en-us/articles/115003615043-How-do-design-polls-work-"
        });
        return noPollPanel.render().html();
      }

      // Create poll option and poll objects
      var designRatingPageUrl = "/design-rating/" + pollingInfo['design_id'];
      var pollOptions = new M.Collection.Design.PollOption(
        pollingInfo['poll_options']);
      var poll = new M.Model.Design.Poll({
        id: pollingInfo['poll_id'],
        options: pollOptions,
        urlPaths: pollingInfo['url_paths']
      });
      // Create the overall poll panel

      var pollPanelComponent = new M.Community.View.Challenge.PollingComponent({
        model: poll,
        headerText: headerText,
        challengeId: pollingInfo['challenge_id'],
        challengeTitle: pollingInfo['challenge_title'],
        pollGalleryUrlPath: pollingInfo['poll_gallery_url_path'],
        pollUrlPaths: pollingInfo['url_paths'],
        pollResponseCount: pollingInfo['response_count'],
        designId: pollingInfo['design_id'],
        designName: pollingInfo['design_name'],
        designRatingPageUrl: designRatingPageUrl,
        designerName: pollingInfo['designer_name'],
        designerLocation: pollingInfo['designer_location'],
        designerAvatarUrl: pollingInfo['profile_img_url'],
        designerProfilePageUrl: pollingInfo['designer_profile_page_url'],
        shouldUsePopupGallery: pollingInfo['should_use_popup_gallery']
      });

      return pollPanelComponent.$containerEl;
    },

    renderAboutChallenge: function(challengeHubView, $parentPanelEl) {
      var templateHTML =
        M.Template.Community.Challenge.AboutChallengePanel({
          challengeSummaryHtml: challengeHubView.model.get('challenge_summary_html'),
          prizeHtml: challengeHubView.model.get('prize_html')
        });

      $parentPanelEl.html(templateHTML);

      // Html from database sometimes contains <style> elements.
      // This is a hack to remove it
      $parentPanelEl.find('style').remove();
    },

    /*
     * This function is actually not rendering the winners panel, but only
     * add showHide panel and like buttons. The real panel rendering is in
     * challenge_gallery_base.mako for SEO reasons.
     */
    renderWinners: function(challengeHubView, $parentPanelEl) {
      var localStorageExpandKey =
        M.LOCAL_STORAGE_KEYS.COMMUNITY.CHALLENGE_HUB.SHOW_WINNERS_PANEL_EXPANDED;
      M.Community.View.Challenge.ChallengeHub._createShowHidePanel(
        $parentPanelEl, 1, 'designsRow', 'pagerControls', false, localStorageExpandKey);

      _.each($parentPanelEl.find('.item'), function(item, position) {
        var $designItem = $(item);
        var designId = $designItem.attr('design_id');

        // Add an overlay with facebook/pinterest pin buttons
        M.Community.View.Challenge.ChallengeHub.
          _constructAndAttachSocialWidgetsOverlay(
            challengeHubView, designId, $designItem);

        // Attack click handler for the "like" button
        M.Community.View.Challenge.ChallengeHub._attachLikeButtonHandlers(
          $designItem.find('.fullLikeButton'), designId);

        // A static function is called to add the award icons on the
        // design image.
        M.Community.View.Design.addAwardIconToDesign($designItem, position);

      });
    },
    /*
     * This function is actually not rendering the winners panel, but only
     * add showHide panel and like buttons. The real panel rendering is in
     * challenge_gallery_base.mako for SEO reasons.
     */
    renderSpecialPrizeWinners: function(challengeHubView, $parentPanelEl) {
      var localStorageExpandKey =
        M.LOCAL_STORAGE_KEYS.COMMUNITY.CHALLENGE_HUB.SHOW_SPECIAL_PRIZE_WINNERS_PANEL_EXPANDED;
      M.Community.View.Challenge.ChallengeHub._createShowHidePanel(
        $parentPanelEl, 1, 'designsRow', 'pagerControls', false, localStorageExpandKey);

      _.each($parentPanelEl.find('.item'), function(item, position) {
        var $designItem = $(item);
        var designId = $designItem.attr('design_id');

        // Add an overlay with facebook/pinterest pin buttons
        M.Community.View.Challenge.ChallengeHub.
          _constructAndAttachSocialWidgetsOverlay(
            challengeHubView, designId, $designItem);

        // Attack click handler for the "like" button
        M.Community.View.Challenge.ChallengeHub._attachLikeButtonHandlers(
          $designItem.find('.fullLikeButton'), designId);

        // A static function is called to add the award icons on the
        // design image.
        M.Community.View.Design.addAwardIconToDesign($designItem, position);

      });
    }
  });

  // Maps challenge state to panel render functions
  // Keep in sync with the mapping dictionary in community/common.py, which is
  // used in challenge_hub.mako
  var CHALLENGE_STAGE_PANELS_MAP = {};
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.setup.id] =
    ['renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.submission.id] =
    ['renderFeedbackAndPolls', 'renderDesignSubmissions', 'renderAboutChallenge', 'renderTopPrizes'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.submission_closed.id] =
    ['renderFeedbackAndPolls', 'renderDesignSubmissions', 'renderAboutChallenge', 'renderTopPrizes'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.nominate.id] =
    ['renderDesignSubmissions', 'renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.nominate_select.id] =
    ['renderDesignSubmissions', 'renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.vote.id] =
    ['renderDesignSubmissions', 'renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.vote_closed.id] =
    ['renderDesignSubmissions', 'renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.restricted_vote.id] =
    ['renderDesignSubmissions', 'renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.restricted_vote_closed.id] =
    ['renderDesignSubmissions', 'renderAboutChallenge'];
  CHALLENGE_STAGE_PANELS_MAP[
      M.Config['ChallengeConfig'].state.published.id] =
    ['renderWinners', 'renderSpecialPrizeWinners', 'renderDesignSubmissions', 'renderAboutChallenge'];

  var ACTIVITY_FEED_STATES = [];
  ACTIVITY_FEED_STATES.push(
    M.Config['ChallengeConfig'].state.submission.id);
  ACTIVITY_FEED_STATES.push(
    M.Config['ChallengeConfig'].state.submission.id_closed);
  ACTIVITY_FEED_STATES.push(
    M.Config['ChallengeConfig'].state.nominate.id);
  ACTIVITY_FEED_STATES.push(
    M.Config['ChallengeConfig'].state.nominate.id_select);
  ACTIVITY_FEED_STATES.push(
    M.Config['ChallengeConfig'].state.vote.id);
  ACTIVITY_FEED_STATES.push(
    M.Config['ChallengeConfig'].state.vote.id_closed);

  // Keep in order with the panels created in challenge_hub.mako: render_panels
  var PANEL_FCN_ORDER = [
    'renderWinners',
    'renderSpecialPrizeWinners',
    'renderFeedbackAndPolls',
    'renderDesignSubmissions',
    'renderAboutChallenge'
  ];

  var PANEL_TO_NAV_LINK_STR_MAP = {
    'renderDesignSubmissions': 'submissions',
    'renderFeedbackAndPolls': 'polls & feedback',
    'renderAboutChallenge': 'brief, prizes & info',
    'renderWinners': 'winners',
    'renderSpecialPrizeWinners': 'special prize winners'
  };

  var PANEL_TO_ELEMENT_ID = {
    'renderDesignSubmissions':        'designSubmissionsPanel',
    'renderAboutChallenge':           'aboutChallengePanel',
    'renderFeedbackAndPolls':         'feedbackAndPollsPanel',
    'renderWinners':                  'winnersPanel',
    'renderSpecialPrizeWinners':      'specialPrizeWinnersPanel'
  };

})(M, _, $, Backbone);
